/*
 * hea-gift-note.js (DEV-474)
 *
 * Drives snippets/hea-gift-note.liquid in the cart drawer and on the cart
 * page. Document-level delegation, so it keeps working after the drawer
 * body or the cart section is re-rendered with innerHTML.
 *
 * Saves two cart attributes through /cart/update.js:
 *   Gift order = "Yes" | ""      Gift note = message | ""
 * A note is only ever saved while the box is checked.
 *
 * Re-renders come from the server's copy of the cart, which can lag the
 * shopper's typing by one save. The last thing the shopper did is kept
 * here and put back into any freshly rendered block, then saved again.
 */
(function () {
  if (window.HEAGiftNote) return;

  var LIMIT = 250;
  var DEBOUNCE_MS = 400;
  var timer = null;
  var inflight = null;
  var local = null; // { on: bool, note: string } once the shopper has touched it

  function q(block, sel) { return block.querySelector(sel); }

  function paint(block, state) {
    var check = q(block, '[data-hea-gift-check]');
    var note = q(block, '[data-hea-gift-note]');
    var panel = q(block, '[data-hea-gift-panel]');
    var flag = q(block, '[data-hea-gift-flag]');
    var clear = q(block, '[data-hea-gift-clear]');
    if (!check || !note) return;
    check.checked = state.on;
    if (note.value !== state.note) note.value = state.note;
    note.disabled = !state.on;
    if (clear) clear.disabled = state.on;
    if (flag) flag.value = state.on ? 'Yes' : '';
    if (panel) panel.hidden = !state.on;
    count(block);
  }

  function read(block) {
    var check = q(block, '[data-hea-gift-check]');
    var note = q(block, '[data-hea-gift-note]');
    return { on: !!(check && check.checked), note: note ? note.value.slice(0, LIMIT) : '' };
  }

  function count(block) {
    var note = q(block, '[data-hea-gift-note]');
    var out = q(block, '[data-hea-gift-count]');
    if (note && out) out.textContent = note.value.length + '/' + LIMIT;
  }

  function status(text) {
    document.querySelectorAll('[data-hea-gift-status]').forEach(function (el) {
      el.textContent = text || '';
      el.hidden = !text;
    });
  }

  function save() {
    clearTimeout(timer);
    timer = null;
    if (!local) return Promise.resolve();
    var on = local.on;
    var note = on ? local.note.replace(/\s+$/, '') : '';
    var body = JSON.stringify({ attributes: { 'Gift order': on ? 'Yes' : '', 'Gift note': note } });
    var run = function () {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: body
      }).then(function (r) {
        if (!r.ok) throw new Error('cart update ' + r.status);
        status('');
        return r.json();
      }).catch(function () {
        status('Your gift note did not save. Please check your connection and try again.');
      });
    };
    // Saves run one after another so an older save can never land last.
    var mine = (inflight || Promise.resolve()).then(run);
    inflight = mine;
    mine.then(function () { if (inflight === mine) inflight = null; });
    return mine;
  }

  function flush() {
    if (timer) return save();
    return inflight || Promise.resolve();
  }

  document.addEventListener('change', function (e) {
    var check = e.target.closest && e.target.closest('[data-hea-gift-check]');
    if (!check) return;
    var block = check.closest('[data-hea-gift]');
    local = read(block);
    paint(block, local);
    if (local.on) {
      var note = q(block, '[data-hea-gift-note]');
      if (note) note.focus();
    }
    save();
  });

  document.addEventListener('input', function (e) {
    var note = e.target.closest && e.target.closest('[data-hea-gift-note]');
    if (!note) return;
    var block = note.closest('[data-hea-gift]');
    if (note.value.length > LIMIT) note.value = note.value.slice(0, LIMIT);
    local = read(block);
    count(block);
    clearTimeout(timer);
    timer = setTimeout(save, DEBOUNCE_MS);
  });

  document.addEventListener('focusout', function (e) {
    if (e.target.closest && e.target.closest('[data-hea-gift-note]') && timer) save();
  });

  // The drawer's Secure Checkout is a plain link; wait for the last save.
  // (The cart page's Checkout buttons submit the form, which carries the
  // fields itself.)
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[data-cart-checkout]');
    if (!link || (!timer && !inflight)) return;
    e.preventDefault();
    flush().then(function () { window.location.href = link.href; });
  }, true);

  // Put the shopper's latest state back into any re-rendered block.
  function addsGiftBlock(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && (n.matches('[data-hea-gift]') || n.querySelector('[data-hea-gift]'))) return true;
      }
    }
    return false;
  }

  var observer = new MutationObserver(function (mutations) {
    if (!local || !addsGiftBlock(mutations)) return;
    document.querySelectorAll('[data-hea-gift]').forEach(function (block) {
      var shown = read(block);
      if (shown.on !== local.on || shown.note !== local.note) {
        paint(block, local);
        if (!timer) save();
      }
    });
  });

  function start() {
    observer.observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);

  window.HEAGiftNote = { flush: flush, limit: LIMIT };
})();
